import { Component, Inject, InjectionToken, Input, OnInit, Optional } from '@angular/core';
import { Subject } from 'rxjs';
import { SiteContentModel } from 'src/app/models/site-content.model';
import { InterpolationService } from 'src/app/services/interpolation.service';
import { SiteContentService } from 'src/app/services/site-content.service';

export const SITE_CONTENT_CLICK = new InjectionToken<Subject<SiteContentClickEvent>>("SITE_CONTENT_CLICK_EVENT$");

export type SiteContentClickEvent = { key: string, event: MouseEvent };

@Component({
  selector: 'app-site-content',
  templateUrl: './site-content.component.html',
  styleUrls: ['./site-content.component.scss']
})
export class SiteContentComponent implements OnInit {

  @Input() key: string;
  @Input() type: string;
  @Input() showTitle = true;
  @Input() data: any = null;

  title: string;
  body: string;
  error: string;

  constructor(
    private siteContentService: SiteContentService,
    private interpolationService: InterpolationService,
    @Optional() @Inject(SITE_CONTENT_CLICK) private clickEvent: Subject<SiteContentClickEvent>
  ) { }

  async ngOnInit() {
    try {
      if (!this.key) {
        this.title = 'Site Content Key Undefined';
        this.body = 'Key undefined';
        return;
      }

      let content: SiteContentModel;
      try {
        content = await this.siteContentService.getSiteContent(this.key);
      } catch (err) {
        console.log(err);
        this.error = `Content ${this.key} not found`;
        return;
      }

      if (this.data) {
        this.title = this.interpolationService.interpolate(content.title, this.data);
        this.body = this.interpolationService.interpolate(content.body, this.data);
      } else {
        this.title = content.title;
        this.body = content.body;
      }

    } catch (err: any) {
      console.log(err);
      this.error = `Error rendering ${this.key}: ${err.message}`;
    }
  }

  onClick(event: MouseEvent) {
    const target = event.currentTarget as HTMLElement;
    if (target.matches('a')) {
      if (this.clickEvent)
        this.clickEvent.next({ key: this.key, event });
    }
  }
}